import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RankmiTable } from '@rankmi/rankmi-table'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import EmptyState from 'components/reusables/emptyState'
import { ModalButtons } from 'components/reusables/modalButtons'
import { Modal } from 'components/reusables/modal'
import { Wrapper, RankmiTableWrapper } from './styled'

interface IProps {
  data: string[]
  close: () => void
}

const AssociatedCourses = ({ data, close }: IProps) => {
  const { t } = useTranslation()
  const translatePrefix = 'administration.certificate.new'
  const [searchCriteria, setSearchCriteria] = useState('')
  const [currentPage, setCurrentPage] = useState(1)

  const locale = {
    header: {
      rowsCount: t(`${translatePrefix}.header.rowsCount`),
      rowsCount_plural: t(`${translatePrefix}.header.rowsCountPlural`),
    },
  }

  const columns = [
    {
      title: t(`${translatePrefix}.courses.name`),
      render: (value: string) => value,
    },
  ]

  const onSearch = (value: string) => {
    setCurrentPage(1)
    setSearchCriteria(value)
  }

  return (
    <Modal
      title={t(`${translatePrefix}.header.associatedCourses`)}
      actions={
        <ModalButtons
          secondaryText={t(`${translatePrefix}.buttons.close`)}
          secondaryAction={close}
        />
      }
      maxheight={500}
      maxwidth={800}
      close={close}
    >
      <Wrapper>
        <RankmiTableWrapper>
          <RankmiTable
            locale={locale}
            columnHeaders={columns}
            data={data
              .filter((item) =>
                item.toLowerCase().includes(searchCriteria.toLowerCase())
              )
              .slice(currentPage * 10 - 10, currentPage * 10)}
            total={
              data.filter((item) =>
                item.toLowerCase().includes(searchCriteria.toLowerCase())
              ).length
            }
            search={searchCriteria}
            onSearch={onSearch}
            onPaginationChange={(value: number) => setCurrentPage(value)}
            currentPage={currentPage}
            countIcon={faBook}
            customEmpty={
              <EmptyState
                title={t(`${translatePrefix}.emptyState.title`)}
                icon={faBook}
              />
            }
          />
        </RankmiTableWrapper>
      </Wrapper>
    </Modal>
  )
}

export default AssociatedCourses
